// extracted by mini-css-extract-plugin
export default {"container":"errorBoundary_container__nFhvB","message":"errorBoundary_message__fZE38","link":"errorBoundary_link__OwqY+"};